const commonConfig = {
  // yuuAddressLib: "https://sit.newco.com.hk/themes/custom/anfield/js/yuu-web-library/51.3.10.1/bundle.js",
  yuuAddressLib: "https://yuurewards.com/themes/custom/anfield/js/yuu-web-library/51.3.10.1/bundle.js",
  googleMapAPI:
    "https://maps.googleapis.com/maps/api/js?key=AIzaSyCD5NvrW06UrC_ZYbmS-qPHBLZ2OuZdygk&libraries=places&callback=initgMapSuccess"
}
export default commonConfig
